import HelperClassContainer from "../../../Components/UiKits/HelperClasses/HelperClassContainer";

const HelperClasses = () => {
  return <HelperClassContainer />;
};

export default HelperClasses;
